import React, { Component, cloneElement } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'
import { Button, Modal, CheckboxField } from '@adc/ui-adc'
import storageService from '../../utils/storageService'
import BidAtCountyInterstitial from '../bidAtCountyInterstital'
import styles from './index.scss'
const cx = classnames.bind(styles)

class BidAtCountySite extends Component {
  static propTypes = {
    venueUrl: PropTypes.string.isRequired,
    children: PropTypes.element.isRequired,
  }

  state = {
    modalOpen: false,
    showLeaveMessage: !storageService.local.get('fclLeaveMessage'),
  }

  showModal = () => {
    this.setState({ modalOpen: true })
  }

  hideModal = () => {
    this.setState({ modalOpen: false })
  }

  onChange = () => {
    this.setState({ showLeaveMessage: !this.state.showLeaveMessage })
  }

  bidAtCountyRedirect = venueUrl => {
    window.open(venueUrl, '_blank')
    if (this.state.modalOpen) {
      this.hideModal()
      if (!this.state.showLeaveMessage)
        storageService.local.set(
          'fclLeaveMessage',
          !this.state.showLeaveMessage
        )
    }
  }

  render() {
    const { modalOpen, showLeaveMessage } = this.state
    const { venueUrl, children } = this.props

    const onClick = () =>
      showLeaveMessage ? this.showModal() : this.bidAtCountyRedirect(venueUrl)

    const button = cloneElement(children, { onClick })

    return (
      <span>
        {button}
        <Modal
          elmId='bid_at_county_modal'
          open={modalOpen}
          onClose={this.hideModal}
          mobileTitleSkin='light'
          size='tiny'
        >
          <Modal.Content>
            <div className={cx('county-redirect-modal')}>
              <h3 className={cx('county-redirect-modal-title')}>
                You are leaving Auction.com
              </h3>
              <BidAtCountyInterstitial />
              <div className={cx('county-redirect-modal-checkbox', 'u-mt-3')}>
                <CheckboxField
                  checked={!showLeaveMessage}
                  onChange={this.onChange}
                  elmId='bid_at_county_modal_checkbox'
                  label='Do not show this message again'
                />
              </div>
              <Button
                role='primary'
                onClick={() => this.bidAtCountyRedirect(venueUrl)}
                elmId='bid_at_county_Modal_continue_button'
              >
                Continue
              </Button>
            </div>
          </Modal.Content>
        </Modal>
      </span>
    )
  }
}

export default BidAtCountySite
